<mat-dialog-content class="modal-content">
  <mat-icon>cancel</mat-icon>
  <h2>
    {{
      data?.message ||
        'Tuvimos un inconveniente en nuestra plataforma, Por favor, espere unos segundos e intente nuevamente'
    }}
  </h2>
</mat-dialog-content>

<mat-dialog-actions class="modal-actions">
  <button class="btn-cancelar" (click)="redirectTo()" mat-flat-button>Aceptar</button>
</mat-dialog-actions>
